export const DREAMCAST = "DreamCast™";

// Matches legacy and rebranded names; "Digital Info" is a separate feature and is left alone.
const dreamCastPattern =
  /digital\s*delivery|dream\s*cast(?:\s*™)?|\bdigital\b(?!\s+info)/gi;

export const normalizeDreamCast = (text) =>
  typeof text === "string" ? text.replace(dreamCastPattern, DREAMCAST) : text;

export const normalizeMembershipTitles = (list) =>
  Array.isArray(list)
    ? list.map((item) => ({ ...item, title: normalizeDreamCast(item?.title) }))
    : list;
